import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as moment from "moment";

@Component({
  selector: 'app-list-unread-conversation',
  templateUrl: './list-unread-conversation.component.html',
  styleUrls: ['./list-unread-conversation.component.scss']
})
export class ListUnreadConversationComponent implements OnInit {
  @Input() clientChat;
  @Output() chatEmitter = new EventEmitter();
  content = '';
  time = '';
  clientId : number;
  name = '';
  constructor() { }

  ngOnInit() {
    this.name = this.clientChat.val.name;
    // @ts-ignore
    this.time = moment(this.clientChat.lastConversation.last_activity.time).format('ll').substr(0, 6);
    this.content = this.clientChat.lastConversation.last_activity.content.length > 20
      ? `${this.clientChat.lastConversation.last_activity.content.substr(0, 20)}... -  ${this.time}` :
      `${this.clientChat.lastConversation.last_activity.content} - ${this.time}` ;
  }
  selectConversation(client){
    this.chatEmitter.emit(client)
    // if (this.clientId === client.val.source_id) {
    //   this.clientId = 0
    // } else {
    //   this.clientId = client.val.source_id
    // }


  }
}
